import { combineReducers } from 'redux';

const defaultProposals = {};
const proposalsList = (state = defaultProposals, action) => {
  switch (action.type) {
    case 'GET_PROPOSALS_BY_COMPANY_SUCCESS':
    case 'GET_PROPOSALS_BY_ID_SUCCESS':
    case 'GET_PROPOSALS_SUCCESS':
      return { ...action.proposals };
    case 'PROPOSALS_COMPANY_CLEAR':
      return defaultProposals;
    default:
      return state;
  }
};

export default combineReducers({
  proposalsList,
});
